import { FC } from "react";
import { FormikField } from "@components/forms/FormikField/FormikField";
import { Picker } from "@design-system/Picker/Picker.lib";
import {
    isWorkspaceTimezone,
    WORKSPACE_TIMEZONE_LABELS,
    WorkspaceTimezone,
} from "@common/workspaceTimezone";
import { useTypedFlags } from "@hooks/useTypedFlags";
import fieldSpacing from "./fieldSpacing.module.scss";
import styles from "./WorkspaceTimezoneField.module.scss";

const timezoneItems = Object.values(WorkspaceTimezone).map((timezone) => ({
    value: timezone,
    label: WORKSPACE_TIMEZONE_LABELS[timezone],
}));

type WorkspaceTimezoneFieldProps =
    | { name: string; fieldName?: never }
    | { name?: never; fieldName: string };

const timezoneFieldName = (props: WorkspaceTimezoneFieldProps): string => {
    if (props.name !== undefined) {
        return props.name;
    }

    return props.fieldName;
};

export const WorkspaceTimezoneField: FC<WorkspaceTimezoneFieldProps> = (
    props,
) => {
    const { workspaceTimezone } = useTypedFlags();
    const name = timezoneFieldName(props);

    if (!workspaceTimezone) {
        return null;
    }

    return (
        <>
            <FormikField<WorkspaceTimezone>
                name={name}
                label="Workspace timezone"
                control="button"
                className={fieldSpacing.buttonField}
            >
                {({ helpers, field, invalid }) => (
                    <Picker.Select
                        items={timezoneItems}
                        value={
                            isWorkspaceTimezone(field.value)
                                ? field.value
                                : null
                        }
                        onValueChange={(value) => {
                            if (value) {
                                helpers.setValue(value);
                            }
                        }}
                        placeholder="Select"
                        aria-invalid={invalid}
                        trigger={
                            <Picker.Button variant="primary" size="xl" block />
                        }
                    />
                )}
            </FormikField>
            <p className={styles.helper}>
                Kick uses this timezone for transaction dates, scheduled tasks,
                and notifications. You can't change it after setup.
            </p>
        </>
    );
};
